import { Component } from '@angular/core';
import { NavParams, Events } from 'ionic-angular';
import { EventData } from '../../providers/event';
import { Tracking } from '../../providers/tracking';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'event-sponsor',
  templateUrl: 'event-sponsor.html'
})

export class EventSponsorComponent {

  obs: any;
  obsSponsor: any;
  obsRelatedSponsor: any;
  obsListener: any;
  event: any;
  client: string;
  dataSponsor: any = false;
  componentState: boolean = false;

  constructor(public eventProvider: EventData, public params: NavParams, events: Events, public track: Tracking) {

    this.event = this.params.get('event');
    this.client = this.params.get('client');

    this.obsListener = this.eventProvider.getListener(this.client, this.event.id, 'sponsor').subscribe(stateModule => {
      if (stateModule.$value === true) {
        this.componentState = true;
      } else {
        this.componentState = false;
      }
    });

    this.obs = new Observable(observer => {
      this.obsSponsor = this.eventProvider.getListSponsor(this.client, this.event.id).subscribe((data: any) => {
        if (data && this.componentState) {
          observer.next(data);
        } else {
          observer.next(false);
        }
      });
    });

    this.obs.subscribe((value) => {
      this.dataSponsor = false;

      if (this.obsRelatedSponsor) {
        this.obsRelatedSponsor.unsubscribe();
      }

      if (value) {
        value.forEach((sponsor: any, key) => {
          this.obsRelatedSponsor = this.eventProvider.getSponsor(this.client, sponsor.sponsorId).subscribe((data: any) => {
            value[key].photo = data.photo;
            value[key].redirect = data.redirect;
            value[key].title = data.title;
            value[key].isClick = data.isClick;
          });
        });

        this.dataSponsor = value;
      } else {
        this.dataSponsor = false;
      }
    });

    // close de listener where logout user
    events.subscribe('client:logout', (r) => {
      this.closeListener();
    });
  }

  go(slide) {
    if (slide.isClick) {
      this.track.saveTrackingSponsor(this.client, this.event.id, slide.sponsorId)
        .then(() => {
          if (slide.redirect) {
            window.open(
              slide.redirect,
              '_blank'
            );
          }
        });
    }
  }

  closeListener() {
    if (this.obsListener) {
      console.log('Se eliminan los observables de Sponsor');
      this.obsListener.unsubscribe();
    }
    if (this.obsSponsor) {
      this.obsSponsor.unsubscribe();
    }
    if (this.obsRelatedSponsor) {
      this.obsRelatedSponsor.unsubscribe();
    }
  }

  // Unsubsucribe observables on exit page
  ngOnDestroy() {
    this.closeListener();
  }
}
// TODO: Review sponsor config node in firebase realtime
// end file



// WEBPACK FOOTER //
// ./src/components/event-sponsor/event-sponsor.ts